<template>
    <transition name="bg" mode="out-in">
        <div :key="background_image" class="o-highlight__background" :style="`background-image: ${!background_image ? 'none' : 'url(' + background_image + ')'};`"></div>
    </transition>
</template>

<script>
export default {
    data: function() {
        return {

        }
    },
    computed: {
        background_image: function() {
            return this.$route.meta.background_image || false;
        }
    }
}
</script>
